import React from 'react';
import { Box, Typography, Paper } from '@mui/material';


const HostPolicy: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      
      <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
        <Typography variant="h4" gutterBottom>
          Host Policy
        </Typography>
        <Typography variant="body1" paragraph>
          This is the host policy. Here you can outline the terms and conditions for hosts using the platform.
        </Typography>
        <Typography variant="h6" gutterBottom>
          1. Listing Properties
        </Typography>
        <Typography variant="body1" paragraph>
          Hosts are responsible for accurately representing their properties in listings. This includes providing clear photos, detailed descriptions, and up-to-date availability.
        </Typography>
        <Typography variant="h6" gutterBottom>
          2. Pricing and Fees
        </Typography>
        <Typography variant="body1" paragraph>
          Hosts set their own nightly rates. A service fee is deducted from each booking to cover platform costs.
        </Typography>
        <Typography variant="h6" gutterBottom>
          3. Cancellations and Refunds
        </Typography>
        <Typography variant="body1" paragraph>
          Hosts can choose from a range of cancellation policies, from flexible to strict. Refunds are issued to guests according to the selected policy.
        </Typography>
      </Paper>
    </Box>
  );
};

export default HostPolicy;
